/**
 * Temporarily, for local testing you need to change the Domain of the cookie
 * 'UserIsAdminHint' from .com to .local in your browser
 */

import React from 'react';
import styled from 'styled-components';

import { WhitePanel } from 'components/Toolkit/WhitePanel/WhitePanel';
import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';
import { media } from 'helpers/breakpoints';
import { safeClick } from 'helpers/Links/Links';

const SButtonGroup = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.S8};
`;

const SLink = styled.a`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing.M16};

  ${media.medium} {
    display: inline-block;
    width: auto;
    margin-left: ${({ theme }) => theme.spacing.S8};
    margin-bottom: 0;
    padding-left: ${({ theme }) => theme.spacing.S8};
    border-left: 1px solid ${({ theme }) => theme.colors.GREY_LIGHT};

    &:first-child {
      margin-left: 0;
      padding-left: 0;
      border-left: none;
    }
  }
`;

interface ILinks {
  title: string;
  url: string;
  dangerous?: boolean;
}

enum Params {
  adId = 'adId',
  userId = 'userId',
}

const links: ILinks[] = [
  {
    title: 'View Ad',
    url: `/admin/ad.jsp?id={${Params.adId}}`,
  },
  {
    title: 'View User Ads',
    url: `/admin/search.do?email={${Params.userId}}`,
  },
  {
    title: 'User Details',
    url: `/ddadmin/user/{${Params.userId}}`,
  },
];

const moreLinks: ILinks[] = [
  {
    title: 'Edit Ad',
    url: `/admin/spring/update/{${Params.adId}}`,
  },
  {
    title: 'Bump Ad',
    url: `/admin/spring/ad/bump/{${Params.adId}}`,
  },
  {
    title: 'Remove Ad',
    url: `/admin/spring/ad/remove/{${Params.adId}}`,
  },
  {
    title: 'Flag as Non Genuine',
    url: `/admin/spring/ad/scam/{${Params.adId}}`,
    dangerous: true,
  },
];

type TParamMap = [Params, string];

function parseUrlParams(url: string, params: TParamMap[]) {
  return params.reduce((newUrl, [key, value]) => {
    return newUrl.replace(`{${key}}`, value);
  }, url);
}

interface IAdminProps {
  adId: number;
  baseUrl?: string;
  userId?: number;
}

function AdminPanel({ adId, baseUrl, userId }: IAdminProps) {
  const params: TParamMap[] = [
    [Params.adId, adId.toString()],
    [Params.userId, userId?.toString() || ''],
  ];

  return (
    <div className="row">
      <div className="columns small-12">
        <WhitePanel className="common-margin-bottom">
          <InfoTitle
            title="Admin Panel"
            listItems={['Useful links that can only be seen by admins']}
          />
          <SButtonGroup>
            {links.map(({ url, title, dangerous }, key) => (
              <SLink
                key={key}
                target="_blank"
                href={`${baseUrl}${parseUrlParams(url, params)}`}
                {...(dangerous! && { onClick: safeClick })}
              >
                {title}
              </SLink>
            ))}
          </SButtonGroup>
          <InfoTitle variant="SMALL" title="More Options" />
          <SButtonGroup>
            {moreLinks.map(({ url, title, dangerous }, key) => (
              <SLink
                key={key}
                target="_blank"
                href={`${baseUrl}${parseUrlParams(url, params)}`}
                {...(dangerous! && { onClick: safeClick })}
              >
                {title}
              </SLink>
            ))}
          </SButtonGroup>
        </WhitePanel>
      </div>
    </div>
  );
}

export { AdminPanel };
